import React from 'react'
import { default as PhoneInputt } from 'react-phone-input-2'

import { Typography } from '@mui/material'

import 'react-phone-input-2/lib/high-res.css'
import { PhoneinputProps } from './PhoneInput.interface'
import { Container } from './PhoneInput.styles'

export const PhoneInput: React.FC<PhoneinputProps> = ({
  label,
  errorLabel,
  compact,
  ...rest
}) => {
  return (
    <Container compact={compact}>
      {label && (
        <Typography id="label" mb="4px" variant="smLight">
          {label}
        </Typography>
      )}
      <PhoneInputt
        {...rest}
        enableSearch
        enableTerritories
        // SC-10692: o campo abria o teclado alfabetico no celular, obrigando a
        // pessoa a trocar para o numerico antes de digitar. No cadastro isso
        // pesa: o mobile e 55% do trafego de /registrar e so 43% dos cadastros
        // (21,4% de conversao contra 34,6% do desktop). `type=tel` +
        // `inputMode=numeric` fazem o teclado ja abrir em numeros.
        inputProps={{
          type: 'tel',
          inputMode: 'numeric',
          autoComplete: 'tel',
          ...rest?.inputProps
        }}
        inputStyle={{
          // 44px e o alvo minimo de toque recomendado (antes 37px) e o
          // font-size de 16px evita o zoom automatico do Safari no iOS, que
          // desalinhava o formulario ao focar o campo. No `compact` o campo
          // divide a linha com Textfields e segue a medida deles.
          height: compact ? '36px' : '44px',
          fontSize: compact ? '14px' : '16px',
          width: '100%',
          fontFamily: "'Inter', Roboto, sans-serif",
          color: !rest?.disabled
            ? 'rgba(0, 0, 0, 0.87)'
            : 'rgba(0, 0, 0, 0.38)',
          lineHeight: '1.4375em',
          ...rest?.inputStyle
        }}
      />
      <Typography color="#990017" mt="4px" variant="xsBold">
        {errorLabel}
      </Typography>
    </Container>
  )
}
